var map = {
	"./cs.json": [
		49352,
		[
			"apps_teachers-dashboard_src_assets_i18n_cs_json"
		]
	],
	"./en.json": [
		83005,
		[
			"apps_teachers-dashboard_src_assets_i18n_en_json"
		]
	],
	"./sk.json": [
		68944,
		[
			"apps_teachers-dashboard_src_assets_i18n_sk_json"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 27633;
module.exports = webpackAsyncContext;